// superset fetches by `Courses_` prefixed event names
// see: [ Courses Instrumentation] (TODO @sophialee: add documentation link when published)
const enum CoursesEvent {
  // IMPRESSIONS:
  openCoursesPage = 'Courses_openCoursesPage',
  viewCourseRowCard = 'Courses_viewCourseRowCard',

  viewSurveyBanner = 'Courses_viewSurveyBanner',
  viewSurveyModal = 'Courses_viewSurveyModal',
  viewSurveyModalIntroStep = 'Courses_viewSurveyModalIntroStep',
  viewSurveyModalCreationStep = 'Courses_viewSurveyModalCreationStep',
  viewSurveyModalExperienceStep = 'Courses_viewSurveyModalExperienceStep',
  viewExploreCoursesBanner = 'Courses_viewExploreCoursesBanner',

  openLessonPage = 'Courses_openLessonPage',
  openNotFoundPage = 'Courses_openNotFoundPage',

  openResetProgressDialog = 'Courses_openResetProgressDialog',
  openLoginRequiredDialog = 'Courses_openLoginRequiredDialog',

  // CLICKS:
  clickCourseRowCard = 'Courses_clickCourseRowCard',

  clickTakeSurveyBanner = 'Courses_clickTakeSurveyBanner',
  clickDismissSurveyBanner = 'Courses_clickDismissSurveyBanner',
  clickExploreCoursesBanner = 'Courses_clickExploreCoursesBanner',
  clickDismissExploreCoursesBanner = 'Courses_clickDismissExploreCoursesBanner',

  clickSurveyModalContinue = 'Courses_clickSurveyModalContinue',
  clickSurveyModalBack = 'Courses_clickSurveyModalBack',
  clickSurveyModalSkip = 'Courses_clickSurveyModalSkip',
  clickSurveyModalClose = 'Courses_clickSurveyModalClose',
  clickCompleteSurvey = 'Courses_clickCompleteSurvey',
  clickRetakeSurvey = 'Courses_clickRetakeSurvey',

  clickLessonComplete = 'Courses_clickLessonComplete',
  clickCourseComplete = 'Courses_clickCourseComplete',

  clickResetProgress = 'Courses_clickResetProgress',
  clickResetProgressMenu = 'Courses_clickResetProgressMenu',

  clickCourseProgressBar = 'Courses_clickCourseProgressBar',
}

export default CoursesEvent;
